import { connect } from 'react-redux';
import { StoreState } from 'Store/Reducers';
import { getEntityById } from 'Store/Settings/Entities/Selectors';
import Contact from 'Components/Organisms/Contact/Contact';
import { getContactByEntityId } from 'Store/Modules/ContactModule/Selectors';
import { useEffect } from 'react';

const EntityCreateContactModule = ({
    entity_id,
    record_id,
    handleValidation,
    
    contact_methods,

    ...props
}: EntityCreateContactModuleProps) => {
    useEffect(() => {
        const isValid = Array.isArray(contact_methods) && contact_methods?.length > 0;

        handleValidation(isValid);
    }, [contact_methods]);

    return <>
        <Contact
            id={record_id}
            entity_id={entity_id}
        />
    </>;
}

interface Props {
    entity_id: string
    record_id: string
    handleValidation: any
};

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.entity_id),
    contact_methods: getContactByEntityId(state, props.record_id),
});

const mapDispatch = {

};

type EntityCreateContactModuleProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityCreateContactModule);